import { render } from "./RecentTransactionsInfoPanel.vue?vue&type=template&id=f3082906&scoped=true"
import script from "./RecentTransactionsInfoPanel.vue?vue&type=script&lang=js"
export * from "./RecentTransactionsInfoPanel.vue?vue&type=script&lang=js"

import "./RecentTransactionsInfoPanel.vue?vue&type=style&index=0&id=f3082906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3082906"]])

export default __exports__